export const blogDataList = [
  {
    imageSrc: "assets/img/blog/Why_does_a_custom_website_design_beats_a_ready_made_template.jpg",
    altText: "blog image 10",
    date: "27 June, 2025",
    comments: 1,
    title: "Why does a Custom Website Design Beats a Ready-Made Template?",
    description: " Custom website design delivers unique branding, faster performance, and stronger SEO. Build a scalable, tailored site that fits your goals not a generic template.",
    blogLink: "/why-does-a-custom-website-design-beats-a-ready-made-template",
    categories: [
             "Web Development", 
        ],
  },
   {
    imageSrc: "assets/img/blog/how_to_choose_the_best_technology_stack_for_your_website_in_2025.png",
    altText: "blog image 9",
    date: "25 June, 2025",
    comments: 1,
    title: "How to Choose the Right Technology for Your Website?",
    description: "Find out how to choose the optimal technology stack for your site in 2025. Learn essential factors, tools, and tricks to keep running. Before picking anything",
    blogLink: "/how-to-choose-the-right-technology-for-your-website",
     categories: [
             "Web Development",
        ],
  },
  {
    imageSrc: "assets/img/blog/frontend_vs_backend.png",
    altText: "blog image 8",
    date: "11 June, 2025",
    comments: 1,
    title: "Frontend vs. Backend - What's the Difference and Why it Matters?",
    description: " Reliable websites and apps need two key types of work: frontend vs. backend, also called frontend vs backend development.The frontend is what users..",
    blogLink: "/frontend-vs-backend-whats-the-difference-and-why-it-matters",
     categories: [
             "Web Development",
        ],
  },
  {
    imageSrc: "assets/img/blog/what-is-web-development.png",
    altText: "blog image 7",
    date: "10 June, 2025",
    comments: 1,
    title: "What Is Web Development? A Simple Guide for Beginners",
    description: "People know web development as the work of making websites and apps that you use through the internet.Building online projects needs both design and code work",
    blogLink: "/what-is-web-development-a-simple-guide-for-beginners",
     categories: [
             "Web Development", 
        ],
  },
  {
    imageSrc: "assets/img/blog/blog_1.jpg",
    altText: "blog image 1",
    date: "15 Jan, 2022",
    comments: 2,
    title: "How digital marketing is different from traditional marketing?",
    description:
      "Traditional marketing is considered when marketing activities for an organization are undertaken in a conventional way such as by television.",
    blogLink: "/how-digital-marketing-is-different-from-traditional-marketing",
     categories: [
             "Digital Marketing", 
        ],
  },
  {
    imageSrc: "assets/img/blog/blog_2.jpg",
    altText: "blog image 2",
    date: "15 Jan, 2022",
    comments: 2,
    title: "How digital marketing helps in business growth?",
    description:
      "With the continuous changing of working culture globally, Digital marketing has taken the place of conventional marketing. With the great evolution of modern technology, small and medium businesses...",
    blogLink: "/how-digital-marketing-helps-in-business-growth",
    categories: [
             "Digital Marketing", 
        ],
  },
  {
    imageSrc: "assets/img/blog/digital__for_gym_image.png",
    altText: "blog image 3",
    date: "15 Jan, 2022",
    comments: 2,
    title: "Top Digital Marketing Strategies for gym",
    description:
      "Nowadays, when people do not have much time for themselves due to the hustle in their lives, they face many health-related issues...",
    blogLink: "/top-digital-marketing-strategies-for-gym",
     categories: [
             "Digital Marketing", 
        ],
  },
  {
    imageSrc: "assets/img/blog/blog_4.jpg",
    altText: "blog image 4",
    date: "15 Jan, 2022",
    comments: 2,
    title: "Top 10 Digital Marketing Strategies for the startups",
    description:
      "It is very difficult to persist in the market and establish your startups when competition is quite high in every business...",
    blogLink: "/top-10-digital-marketing-strategies-for-the-startups",
     categories: [
             "Digital Marketing", 
        ],
  },
  {
    imageSrc: "assets/img/blog/blog_5.jpg",
    altText: "blog image 5",
    date: "15 Jan, 2022",
    comments: 2,
    title: "Top Digital Marketing Strategies for product...",
    description:
      "We all are always stay awaited for the product launch program as after paying much attention and hard work the final day comes in life when you are launching your products in front of hundreds of people who might be a business person, ",
    blogLink: "/top-digital-marketing-strategies-for-the-product-launch",
     categories: [
             "Digital Marketing", 
        ],
  },
  {
    imageSrc: "assets/img/blog/blog_6.jpg",
    altText: "blog image 6",
    date: "15 Jan, 2022",
    comments: 2,
    title: "How does Digital Marketing Help Small Businesses?",
    description:
      "It's a fact that good marketing plays a crucial role in growing a business. It can enhance your business and boost confidence...",
    blogLink: "/how-does-digital-marketing-help-small-businesses",
     categories: [
             "Digital Marketing",  
        ],
  },
];
